var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:currentColor;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.904,156.934c0-9.333-7.578-16.903-16.903-16.903c-9.333,0-16.903,7.57-16.903,16.903 c0,9.326,7.57,16.903,16.903,16.903C265.326,173.837,272.904,166.26,272.904,156.934z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.548,322.484c-9.333,0-16.902,7.57-16.902,16.903c0,9.325,7.569,16.895,16.902,16.895 c9.326,0,16.903-7.57,16.903-16.895C90.451,330.054,82.874,322.484,73.548,322.484z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.03,198.424c-6.59,6.604-6.59,17.298,0,23.903c6.604,6.597,17.306,6.597,23.911,0 c6.596-6.605,6.596-17.298,0-23.903C132.336,191.819,121.635,191.819,115.03,198.424z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.06,198.424c-6.597,6.604-6.597,17.298,0,23.903c6.604,6.597,17.306,6.597,23.903,0 c6.596-6.605,6.596-17.298,0-23.903C390.358,191.819,379.664,191.819,373.06,198.424z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M438.452,322.484c-9.333,0-16.902,7.57-16.902,16.903c0,9.325,7.57,16.895,16.902,16.895 c9.326,0,16.896-7.57,16.896-16.895C455.348,330.054,447.778,322.484,438.452,322.484z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M316.073,196.554c-1.71-0.638-3.633,0.06-4.538,1.649l-66.654,117.668c-17.914,4.887-31.1,21.227-31.1,40.684 c0,23.31,18.91,42.212,42.22,42.212s42.212-18.902,42.212-42.212c0-8.641-2.6-16.667-7.053-23.356l27.239-132.427 C318.771,198.994,317.776,197.2,316.073,196.554z M256,373.01c-9.09,0-16.462-7.364-16.462-16.455 c0-9.089,7.372-16.454,16.462-16.454c9.09,0,16.462,7.365,16.462,16.454C272.462,365.646,265.091,373.01,256,373.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437.016,159.906C390.738,113.598,326.645,84.914,256,84.922c-70.652-0.008-134.738,28.676-181.016,74.984 C28.676,206.184-0.007,270.277,0,340.922c-0.007,30.204,5.26,59.221,14.889,86.156h29.877 c-10.853-26.57-16.865-55.626-16.865-86.156c0.008-63.021,25.506-119.97,66.814-161.285c41.314-41.3,98.249-66.799,161.285-66.814 c63.037,0.016,119.963,25.515,161.285,66.814c41.3,41.315,66.806,98.264,66.814,161.285c0,30.53-6.02,59.586-16.873,86.156h29.884 C506.734,400.143,512,371.125,512,340.922C512.008,270.277,483.325,206.184,437.016,159.906z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/meter.6ca1648a5579e69c1b94d953285e87b0.svg";
export { ForwardRef as ReactComponent };